<template>
  <section id="section-primary" class="section-primary">
    <h2 :class="align">{{headline}}</h2>
    <div :class="align">
      <slot name="contents" ></slot>
    </div>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'SectionPrimary',
  props: {
    headline: {
      type: String,
      default: 'タイトル'
    },
    text: {
      type: String,
      default: '説明テキスト'
    },
    align: {
      type: String,
      default: 'center'
    }
  }
}
</script>

<style scoped>
h2 {
  font-size: var(--huge-font-size);
  line-height: 1.5;
  margin-bottom: 3.2rem;
  font-weight: var(--bold-font-weight);
}
p {
  font-size: var(--normal-font-size);
  line-height: 2.5;
  margin-bottom: 4.8rem;
  font-weight: var(--bold-font-weight);
}

.section-primary {
  margin-top: 12rem
}

.center {
  text-align: center;
}

.left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/SectionPrimary.vue